/**
 * Hair Matters — Collection / search page performance
 *
 * On PLPs the biggest costs are:
 * - All product images marked loading="lazy" (hurts LCP)
 * - Secondary hover images downloading with the primary
 * - Judge.me full widget stack for star badges only
 * - WhatsApp chat JS on every collection view
 *
 * This script (collection + search only):
 * 1) Promotes first-row primary images to eager + fetchpriority
 * 2) Loads secondary hover images only on first hover/touch
 * 3) Defers Judge.me loader until idle (badge HTML still renders)
 * 4) Defers WhatsApp scripts until first interaction
 */
(function () {
  'use strict';

  var pageType =
    (window.Shopify && Shopify.analytics && Shopify.analytics.meta && Shopify.analytics.meta.page && Shopify.analytics.meta.page.pageType) ||
    (document.body && (document.body.className.match(/template-(\S+)/) || [])[1]) ||
    '';

  var isCollectionLike =
    pageType === 'collection' ||
    pageType === 'search' ||
    (document.documentElement &&
      (document.documentElement.classList.contains('template-collection') ||
        document.documentElement.classList.contains('template-search'))) ||
    /\/collections\//.test(location.pathname) ||
    /\/search/.test(location.pathname);

  if (!isCollectionLike) return;

  var LOG = '[hm-collection]';
  var EAGER_COUNT = 8;
  var HIGH_PRIORITY_COUNT = 4;
  var IDLE_MS = 2800;
  var DESIGN_MODE =
    (window.Shopify && Shopify.designMode) ||
    document.documentElement.classList.contains('shopify-design-mode');

  var JM_RE = /judgeme|judge\.me/i;
  var WA_RE = /whatsapp|njt-whatsapp/i;
  var SCRIPT_RE = /judgeme|judge\.me|whatsapp|njt-whatsapp/i;

  var queuedJm = [];
  var queuedWa = [];
  var jmReleased = false;
  var waReleased = false;
  var origCreateElement = document.createElement.bind(document);

  function log() {
    if (typeof console !== 'undefined' && console.log) {
      console.log.apply(console, [LOG].concat([].slice.call(arguments)));
    }
  }

  function nowMs() {
    return Math.round(
      (window.performance && performance.now && performance.now()) || Date.now()
    );
  }

  /* ---------- 1) First-row images eager ---------- */
  function promoteCardImages() {
    var items = document.querySelectorAll(
      '.product-grid__item[data-hm-eager="1"], .product-grid__item'
    );
    var seen = {};
    var promoted = 0;
    for (var i = 0; i < items.length && promoted < EAGER_COUNT; i++) {
      var item = items[i];
      if (seen[item.id || i]) continue;
      seen[item.id || i] = 1;
      // Prefer marked first-row items; skip unmarked once we have enough eagers
      if (item.getAttribute('data-hm-eager') !== '1' && promoted >= HIGH_PRIORITY_COUNT) {
        continue;
      }
      var imgs = item.querySelectorAll(
        'card-media img, .card__media img, .media img, .card--block-media img'
      );
      if (!imgs.length) continue;
      var primary = null;
      for (var j = 0; j < imgs.length; j++) {
        if (!imgs[j].getAttribute('data-hm-hover-src')) {
          primary = imgs[j];
          break;
        }
      }
      if (!primary) continue;
      primary.setAttribute('loading', 'eager');
      primary.loading = 'eager';
      if (promoted < HIGH_PRIORITY_COUNT) {
        primary.setAttribute('fetchpriority', 'high');
      }
      promoted += 1;
    }
    if (promoted) log('eager-promoted primary images:', promoted, 'at T=' + nowMs() + 'ms');
  }

  var imgMo = new MutationObserver(function () {
    promoteCardImages();
  });
  imgMo.observe(document.documentElement, { childList: true, subtree: true });

  function stopImgMoSoon() {
    promoteCardImages();
    setTimeout(function () {
      imgMo.disconnect();
      promoteCardImages();
    }, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stopImgMoSoon);
  } else {
    stopImgMoSoon();
  }

  /* ---------- 2) Secondary hover images on demand ---------- */
  function hydrateHoverImage(img) {
    var src = img.getAttribute('data-hm-hover-src');
    if (!src) return;
    img.setAttribute('src', src);
    img.removeAttribute('data-hm-hover-src');
    // Restore srcset if we stashed it
    var srcset = img.getAttribute('data-hm-hover-srcset');
    if (srcset) {
      img.setAttribute('srcset', srcset);
      img.removeAttribute('data-hm-hover-srcset');
    }
  }

  function armHoverImages(root) {
    var scope = root || document;
    var imgs = scope.querySelectorAll('img[data-hm-hover-src]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.getAttribute('data-hm-hover-armed') === '1') continue;
      img.setAttribute('data-hm-hover-armed', '1');
      // Strip live srcset so browser doesn't fetch hover asset early
      if (img.srcset) {
        img.setAttribute('data-hm-hover-srcset', img.srcset);
        img.removeAttribute('srcset');
      }
    }
  }

  function onCardIntent(e) {
    var card = e.target && e.target.closest
      ? e.target.closest('.card-wrapper, .product-card-wrapper, .card--block, .product-grid__item')
      : null;
    if (!card) return;
    var imgs = card.querySelectorAll('img[data-hm-hover-src]');
    for (var i = 0; i < imgs.length; i++) hydrateHoverImage(imgs[i]);
  }

  document.addEventListener('pointerenter', onCardIntent, true);
  document.addEventListener('touchstart', onCardIntent, { capture: true, passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      armHoverImages(document);
    });
  } else {
    armHoverImages(document);
  }

  var hoverMo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches('img[data-hm-hover-src]')) armHoverImages(n.parentNode || document);
        else if (n.querySelectorAll) armHoverImages(n);
      }
    }
  });
  hoverMo.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () {
    hoverMo.disconnect();
  }, 8000);

  /* ---------- 3/4) Defer Judge.me + WhatsApp scripts ---------- */
  function matchesQueued(src) {
    return !!(src && SCRIPT_RE.test(src));
  }

  // Also catch HTML-parser scripts as early as possible with a synchronous
  // DOMContentLoaded is too late for defer download — MO during parse is key.
  // Strengthen: when a matching deferred script is found, blank src before it runs.
  function neutralizeScript(script) {
    if (!script || script.tagName !== 'SCRIPT') return;
    if (script.getAttribute('data-hm-coll-defer') === '1') return;
    var src = script.getAttribute('src') || '';
    if (!src) src = script.src || '';
    if (!src || !matchesQueued(src)) return;

    var isJm = JM_RE.test(src);
    var isWa = WA_RE.test(src);
    if (isJm && jmReleased) return;
    if (isWa && waReleased) return;
    if (!isJm && !isWa) return;

    script.setAttribute('data-hm-coll-defer', '1');
    script.setAttribute('data-hm-src', src);
    try {
      script.type = 'text/plain';
    } catch (e1) {}
    try {
      script.removeAttribute('src');
    } catch (e2) {}

    var entry = { src: src, async: true };
    if (isJm) queuedJm.push(entry);
    if (isWa) queuedWa.push(entry);
    log('queued', isJm ? 'judgeme' : 'whatsapp', src.replace(/^https?:\/\//, '').slice(0, 70));
  }

  document.createElement = function (tagName) {
    var el = origCreateElement.apply(document, arguments);
    if (String(tagName).toLowerCase() !== 'script') return el;

    var realSrc = '';
    Object.defineProperty(el, 'src', {
      configurable: true,
      enumerable: true,
      get: function () {
        return realSrc;
      },
      set: function (value) {
        realSrc = value || '';
        if (!DESIGN_MODE && matchesQueued(realSrc)) {
          var isJm = JM_RE.test(realSrc);
          var isWa = WA_RE.test(realSrc);
          if ((isJm && !jmReleased) || (isWa && !waReleased)) {
            el.setAttribute('data-hm-coll-defer', '1');
            el.setAttribute('data-hm-src', realSrc);
            var entry = { src: realSrc, async: true };
            if (isJm) queuedJm.push(entry);
            if (isWa) queuedWa.push(entry);
            log('queued(create)', isJm ? 'judgeme' : 'whatsapp', realSrc.slice(0, 70));
            return;
          }
        }
        el.setAttribute('src', realSrc);
      }
    });
    return el;
  };

  var scriptMo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.nodeType !== 1) continue;
        if (n.tagName === 'SCRIPT') neutralizeScript(n);
        else if (n.querySelectorAll) {
          var scripts = n.querySelectorAll('script[src]');
          for (var k = 0; k < scripts.length; k++) neutralizeScript(scripts[k]);
        }
      }
    }
  });
  scriptMo.observe(document.documentElement, { childList: true, subtree: true });

  function injectScripts(list) {
    for (var i = 0; i < list.length; i++) {
      var q = list[i];
      var s = origCreateElement('script');
      s.async = q.async !== false;
      s.src = q.src;
      (document.head || document.documentElement).appendChild(s);
    }
  }

  function releaseJudgeMe(reason) {
    if (jmReleased) return;
    jmReleased = true;
    log('release Judge.me at T=' + nowMs() + 'ms (' + reason + ') n=' + queuedJm.length);
    injectScripts(queuedJm);
    queuedJm = [];
  }

  function releaseWhatsApp(reason) {
    if (waReleased) return;
    waReleased = true;
    log('release WhatsApp at T=' + nowMs() + 'ms (' + reason + ') n=' + queuedWa.length);
    injectScripts(queuedWa);
    queuedWa = [];
  }

  function maybeRestoreCreateElement() {
    if (jmReleased && waReleased) {
      document.createElement = origCreateElement;
      scriptMo.disconnect();
    }
  }

  function onFirstInteraction() {
    releaseWhatsApp('interaction');
    maybeRestoreCreateElement();
  }

  ['pointerdown', 'keydown', 'touchstart', 'scroll'].forEach(function (ev) {
    window.addEventListener(ev, onFirstInteraction, { passive: true, once: true });
  });

  function scheduleIdleJudgeMe() {
    if (DESIGN_MODE) {
      releaseJudgeMe('design-mode');
      releaseWhatsApp('design-mode');
      maybeRestoreCreateElement();
      return;
    }
    function warm() {
      releaseJudgeMe('idle');
      maybeRestoreCreateElement();
    }
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(function () {
        setTimeout(warm, IDLE_MS);
      }, { timeout: IDLE_MS + 2000 });
    } else {
      setTimeout(warm, IDLE_MS + 1000);
    }
  }

  function collectDeferredPlaceholders() {
    var nodes = document.querySelectorAll('script[data-hm-src], script[data-hm-coll-defer="1"]');
    for (var i = 0; i < nodes.length; i++) {
      var script = nodes[i];
      var src = script.getAttribute('data-hm-src') || script.getAttribute('src') || '';
      if (!src) continue;
      var isJm = JM_RE.test(src);
      var isWa = WA_RE.test(src);
      if (!isJm && !isWa) continue;
      var entry = { src: src, async: true };
      if (isJm) queuedJm.push(entry);
      if (isWa) queuedWa.push(entry);
      log('queued(placeholder)', isJm ? 'judgeme' : 'whatsapp', src.replace(/^https?:\/\//, '').slice(0, 70));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      // Catch parser-inserted deferred scripts still in DOM
      var scripts = document.querySelectorAll('script[src]');
      for (var i = 0; i < scripts.length; i++) neutralizeScript(scripts[i]);
      collectDeferredPlaceholders();
      scheduleIdleJudgeMe();
    });
  } else {
    collectDeferredPlaceholders();
    scheduleIdleJudgeMe();
  }

  // Safety nets
  setTimeout(function () {
    releaseJudgeMe('timeout');
    maybeRestoreCreateElement();
  }, 12000);
  setTimeout(function () {
    releaseWhatsApp('timeout');
    maybeRestoreCreateElement();
  }, 20000);
})();
